import * as React from 'react';
import {useE4ImpactProjectsContext} from '../../context';
import {ChartsContainer} from '../../Common/ChartsContainer';
import {configSchema} from './configSchema';

export function ShortTermOutcomes() {
    const {baselineSubmissions, finalSubmissions} = useE4ImpactProjectsContext();

    return <ChartsContainer
        configSchema={configSchema({
            baselineSubmissions,
            finalSubmissions,
        })}
    />
}